
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[productName]/[productId]/[variantId]",
      function () {
        return require("private-next-pages/p/[productName]/[productId]/[variantId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[productName]/[productId]/[variantId]"])
      });
    }
  